import React, { Component } from 'react';
import FetchVClientSearch from './FetchVClientSearch';

import './KPI.scss';

function parseJwt (token) {  
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}


export default class KPI extends Component {
    constructor(props){
        super(props);

        this.state = {
            AdminTab: false
        };
    }

    async componentDidMount(){   

        fetch(`${process.env.PUBLIC_URL}/config.json`)
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            let config = data.config;
            let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
            if(config.ErrorNotification.includes(jwt.oid)){
                this.setState({
                    AdminTab : true
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });

    }

    render(){
        return (
            <div className="kpi-content" id="KPI" >     
                <FetchVClientSearch isAdmin={this.state.AdminTab} />            
            </div>       
       );
    }
}

